export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11518.8a423b5f.jpg";